import styled from '@emotion/styled';
import { Select } from '@mui/material';

const StyledSelect = styled(Select)({
  width: 320,
  maxWidth: '100%',
}) as unknown as typeof Select;

export default StyledSelect;
